import React, { Component } from "react";
import "./App.css";
import Home from "./Home";
import {getMessage} from "./util";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

const queryString = require("query-string");

class App extends Component {
	render() {
		return (
			<Router basename="/VA1093w9">
				<div>
					<Route path="/"  component={Home} />
				</div>
			</Router>
		);
	}
}



export default App;
